import React, { useState, useEffect } from 'react'
import { cloneDeep } from 'lodash-es'
import { Panel, Grid, Row, Placeholder, Table, IconButton, Icon } from 'rsuite'
import TooltipButton from '../../../../components/buttons/TooltipButton'

export default function BackgroundOfElderlyView({ schema: _schema, onDownload }) {
  const { Graph } = Placeholder

  const styles = {
    marginTop10: {
      marginTop: 10,
    },
    marginTop20: {
      marginTop: 20,
    },
  }

  const { Column, HeaderCell, Cell } = Table
  const [frequentAccidentsPointList, setFrequentAccidentsPointList] = useState([])
  const [schema, setSchema] = useState(_schema)
  const [riskPointSchema, setRiskPointSchema] = useState(_schema.riskPointSchema)
  const [dataList, setDataList] = useState()

  useEffect(() => {
    const cloneSchema = cloneDeep(_schema)
    setSchema(cloneSchema)
    setRiskPointSchema(cloneSchema.riskPointSchema)

    let accidentsPoints = [...cloneSchema.frequentAccidentsPointList.value]

    setFrequentAccidentsPointList(accidentsPoints)

    setDataList([])
  }, [_schema])

  useEffect(async () => {
    var dataList = await mapData(frequentAccidentsPointList)

    // frequentAccidentsPointList.forEach((item) => {
    //   const riskPoints = item.riskPoints.map((riskPoint, index) => {
    //     riskPoint['no'] = index + 1
    //     return riskPoint
    //   })

    //   let childrens = riskPoints || []

    //   let obj = {
    //     id: item.id,
    //     area: getAccidentPointLabel(item),
    //     children: childrens,
    //   }

    //   dataList.push(obj)
    // })

    setDataList(dataList)
    // console.log('dataList', dataList)
  }, [frequentAccidentsPointList])

  const getAccidentPointLabel = (data) => {
    var name
    schema.accidentPoint.options.forEach((item) => {
      if (item.value == data.accidentPoint) {
        name = item.label
        data.accidentPoint === 9 && (name += ' ' + data.otherAccidentPoint)
        return
      }
    })

    return name
  }

  const mapData = async (accidentsPoints) => {
    var dataList = []
    accidentsPoints.forEach((item) => {
      const accidentsPoint = {
        id: item.id,
        area: getAccidentPointLabel(item),
      }
      dataList.push(accidentsPoint)

      item.riskPoints.forEach((riskPoint, index) => {
        riskPoint['no'] = index + 1
        dataList.push(riskPoint)
      })
    })
    // console.log('accidentsPoints', accidentsPoints)
    return dataList
  }

  const paragraph = <>&nbsp; &nbsp; &nbsp;</>

  const NatureOfIncident = ({ rowData, dataKey, ...props }) => (
    <Cell {...props}>
      {rowData.point && (
        <>
          <p>{`${riskPointSchema.point.label} ${rowData.no} ${rowData.point}`}</p>
          <br />
          <p>
            <b>{riskPointSchema.fixRiskPoint.label}</b>
          </p>
          <p style={{ marginLeft: 10 }}>
            {riskPointSchema.fixRiskPoint.options.find(
              (element) => element.value == rowData.fixRiskPoint
            )?.label || '- ไม่ได้ระบุ'}
          </p>
        </>
      )}
    </Cell>
  )

  const CauseOfProblem = ({ rowData, dataKey, ...props }) => (
    <Cell {...props}>
      {rowData.point && rowData.driverBehavior && (
        <>
          <p>
            <b>พฤติกรรม</b>
          </p>
          {riskPointSchema.driverBehavior.options.map((item) => {
            if (rowData.driverBehavior.some((e) => e == item.value)) {
              return (
                <p style={{ marginLeft: 10 }}>
                  &#9679; {item.label} {item.value === 9 && rowData.otherDriverBehavior}
                </p>
              )
            }
          })}
          <br />
          <p>
            <b>{riskPointSchema.environment.label}</b>
          </p>
          {rowData.environment ? (
            <div
              style={{ marginLeft: 10 }}
              dangerouslySetInnerHTML={{
                __html: rowData.environment,
              }}
            />
          ) : (
            <div style={{ marginLeft: 10 }}>
              <p>- ไม่ได้ระบุ</p>
            </div>
          )}
        </>
      )}
    </Cell>
  )

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row style={styles.marginTop10}>
            <p>
              <b>
                {paragraph}
                {schema.accidentProblem.label}
              </b>
            </p>
            <p>
              <b>
                {paragraph}
                {schema.communityInfo.label}
              </b>
            </p>

            {schema.communityInfo.value ? (
              <div
                style={{ marginLeft: 30 }}
                dangerouslySetInnerHTML={{ __html: schema.communityInfo.value }}
              />
            ) : (
              <div style={{ marginLeft: 30 }}>
                <Graph height={9} width={'95%'} style={{ marginLeft: 10 }} />
                <Graph height={9} />
                <Graph height={9} />
              </div>
            )}
          </Row>

          <Row style={styles.marginTop10}>
            <p>
              <b>
                {paragraph}
                {schema.accidentProblemDetail.label}
              </b>
            </p>
            <Row style={{ marginLeft: 30, marginTop: 10 }}>
              <p>
                {schema.accidentRiskPoint.label}{' '}
                {schema.accidentRiskPoint.value ? schema.accidentRiskPoint.value : paragraph}{' '}
                {schema.accidentRiskPoint.postLabel}
              </p>
            </Row>
            <Row style={{ marginLeft: 30, marginTop: 10 }}>
              <p>{schema.frequentAccidentsPointList.label} </p>

              <Table
                style={{ marginTop: 10 }}
                // isTree
                // defaultExpandAllRows={true}
                rowKey="id"
                cellBordered
                // height={400}
                autoHeight
                wordWrap
                headerHeight={60}
                data={dataList}
              >
                <Column width={200}>
                  <HeaderCell align="center" verticalAlign="middle" wordWrap>
                    บริเวณจุดที่เกิดอุบัติเหตุบ่อย
                  </HeaderCell>
                  <Cell dataKey="area" />
                </Column>
                <Column width={200}>
                  <HeaderCell align="center" verticalAlign="middle" wordWrap>
                    ลักษณะการเกิดเหตุ
                  </HeaderCell>
                  <NatureOfIncident dataKey="point" />
                </Column>
                <Column minWidth={200} wordWrap flexGrow={1}>
                  <HeaderCell align="center" verticalAlign="middle" wordWrap>
                    สาเหตุของปัญหาที่ทำให้เกิดอุบัติเหตุที่จุดเสี่ยง
                  </HeaderCell>
                  <CauseOfProblem dataKey="no" />
                </Column>
                <Column width={210}>
                  <HeaderCell align="center" verticalAlign="middle" wordWrap>
                    ผลกระทบ (1 ปีที่ผ่านมา)
                  </HeaderCell>
                  <Cell>
                    {(rowData) => {
                      if (rowData.point && rowData.numOfAccidents) {
                        return (
                          <div>
                            <p>
                              {riskPointSchema.numOfAccidents.preLabel}{' '}
                              <b>{rowData.numOfAccidents}</b>{' '}
                              {riskPointSchema.numOfAccidents.postLabel}
                            </p>
                            <p>
                              {riskPointSchema.died.preLabel} <b>{rowData.died}</b>{' '}
                              {riskPointSchema.died.postLabel}
                            </p>
                            <p style={{ marginLeft: 10 }}>
                              &#9679; {riskPointSchema.diedMan.preLabel} <b>{rowData.diedMan}</b>{' '}
                              {riskPointSchema.diedMan.postLabel}
                            </p>
                            <p style={{ marginLeft: 10 }}>
                              &#9679; {riskPointSchema.diedWomen.preLabel}{' '}
                              <b>{rowData.diedWomen}</b> {riskPointSchema.diedWomen.postLabel}
                            </p>
                            <p>
                              {riskPointSchema.injured.preLabel} <b>{rowData.injured}</b>{' '}
                              {riskPointSchema.injured.postLabel}
                            </p>
                            <p style={{ marginLeft: 10 }}>
                              &#9679; {riskPointSchema.injuredMan.preLabel}{' '}
                              <b>{rowData.injuredMan}</b> {riskPointSchema.injuredMan.postLabel}
                            </p>
                            <p style={{ marginLeft: 10 }}>
                              &#9679; {riskPointSchema.injuredWomen.preLabel}{' '}
                              <b>{rowData.injuredWomen}</b> {riskPointSchema.injuredWomen.postLabel}
                            </p>
                          </div>
                        )
                      }
                    }}
                  </Cell>
                </Column>
                <Column width={60} align="right" fixed="right" verticalAlign="top">
                  <HeaderCell align="center" verticalAlign="middle" wordWrap></HeaderCell>
                  <Cell>
                    {(rowData) => {
                      if (rowData.filePath) {
                        return (
                          <TooltipButton
                            icon="image"
                            tooltip={`ภาพประกอบ`}
                            onClick={(e) => onDownload(rowData.id, rowData.fileName)}
                          ></TooltipButton>
                        )
                      }
                    }}
                  </Cell>
                </Column>
              </Table>
            </Row>
            <Row style={{ marginLeft: 30, marginTop: 10 }}>
              <p>{schema.loss.label}</p>
              {schema.loss.value ? (
                <div dangerouslySetInnerHTML={{ __html: schema.loss.value }} />
              ) : (
                <div>
                  <Graph height={9} width={'97%'} style={{ marginLeft: 10 }} />
                  <Graph height={9} />
                  <Graph height={9} />
                </div>
              )}
            </Row>
          </Row>
        </Grid>
      </Panel>
    </>
  )
}
